export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9879_NO_SCORE': 'No Score',
    '_7360_FILTER': 'Filter',
    '_9796_PREVIOUS': 'Previous',
    '_9589_CURRENT': 'Current',
    '_9860_IMPROVEMENT': 'Improvement',
    '_9861_SELECT_A_PREVIOUS_SCORECARD_CATEGORY': 'Select a Previous Scorecard Category',
    '_9862_SELECT_A_CURRENT_SCORECARD_CATEGORY': 'Select a Current Scorecard Category',
    '_9863_SELECT_AN_IMPROVEMENT_CATEGORY': 'Select an Improvement Category',
    '_9864_APPLY_FILTER': 'Apply Filter',
    '_9865___NUM___POSITIONS': '{{num}} Positions',
    '_9866_NO_MI2_DATA_AVAILABLE': 'No MI2 Data Available',
    '_7460_CURRENT_PERIOD': 'Current Period',
    '_9881_PREVIOUS_PERIOD': 'Previous Period',
    '_7313_LAST_UPDATE': 'Last Update',
    '_842_N_A': 'N/A',
    '_9402_NA': 'NA'
};
